import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { processDecline } from '../../../../actions/PublicWebsiteActions';
import { hideModal } from '../../../../actions/ModalActions';

/* css imports */
import './DeclineRsvpRequestModal.less';


class DeclineRsvpRequestModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // altActive: false,
    };
  }

  render() {
    const { onDecline, onCloseModal, notificationObject } = this.props;
    return (
      <div className="decline-modal-container" id="decline-modal">
        <div className="body">
          <h1>Are you sure you want to decline RSVP access?</h1>
          <p>Your guest will <b>not</b> receive any more communications from Zola.
          </p>
        </div>
        <div className="cta-section">
          <div className="ctas">
            <button className="btn btn-secondary btn-wide" onClick={() => onCloseModal()} >CANCEL</button>
            <button className="btn btn-wide btn-primary danger-btn" onClick={() => onDecline(notificationObject)}>Yes, Decline Access</button>
          </div>
        </div>
        <div className="bottom-copy">
          <p>Need some RSVP guidance? We&apos;ve got you covered. <a href="https://help.zola.com/hc/en-us/sections/115000790951-RSVP">Learn More &rsaquo;</a></p>
        </div>
      </div>
    );
  }
}

DeclineRsvpRequestModal.propTypes = {
  onDecline: PropTypes.func,
  onCloseModal: PropTypes.func,
  notificationObject: PropTypes.shape({})
};

const mapStateToProps = state => (
  {
    guestRequestNotifications: state.publicWebsite.guestRequestObject ? state.publicWebsite.guestRequestObject : null,
    activeGuestPage: state.publicWebsite.activeGuestPage
  }
);

const mapDispatchToProps = dispatch => (
  {
    onDecline: notificationObject => dispatch(processDecline(notificationObject)),
    onCloseModal: () => dispatch(hideModal())
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeclineRsvpRequestModal);



// WEBPACK FOOTER //
// ./src/components/common/modals/DeclineRsvpRequestModal/DeclineRsvpRequestModal.jsx